import { gatewayAmazonConnect } from "../../../../gateways/gatewayAmazonConnect";

export const previewPortingPDF = async (formData: Record<string, any>) => {
  try {
    const response = await gatewayAmazonConnect.post("porting/register?save=false", formData, {
      responseType: "blob", 
      headers: { "Content-Type": "application/json" },
    });

    const pdfBlob = new Blob([response.data], { type: "application/pdf" });

    return pdfBlob
  } catch (error) {
    console.error("Error al generar PDF:", error);
    throw error;
  }
};
